import { makeClassNameHelper } from '../../Utils/ComponentUtils';
import './StepBoxes.css';

export const cxStepBoxes = makeClassNameHelper('StepBoxes');
